import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=2f314b20"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=2f314b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports